import React from 'react';
import { Box, Typography } from '@mui/material';
import { tok, LABEL, MONO, GROTESK, fmtPct, fmtMoney, fmtNum } from './ui';
import HypotheticalLegend from './HypotheticalLegend';

// Six headline tiles, one basis (named), colour only where it carries meaning (DWLF-306).
export default function KpiStrip({ headline }) {
  if (!headline) return null;
  const h = headline;
  const tiles = [
    { k: 'Total return', v: fmtPct(h.returnPct), sub: fmtMoney(h.returnAbs), tone: h.returnPct === null ? 'text' : h.returnPct >= 0 ? 'up' : 'down' },
    { k: 'Max drawdown', v: h.maxDrawdownPct === null ? '—' : `−${Math.abs(h.maxDrawdownPct).toFixed(2)}%`, sub: 'peak to trough', tone: h.maxDrawdownPct === null ? 'text' : 'down' },
    { k: 'Win rate', v: h.winRatePct === null ? '—' : `${h.winRatePct.toFixed(0)}%`, sub: h.wins !== null && h.trades !== null ? `${h.wins} of ${h.trades} trades` : h.trades !== null ? `${h.trades} trades` : '', tone: 'text' },
    { k: 'Profit factor', v: fmtNum(h.profitFactor), sub: 'gross profit ÷ gross loss', tone: h.profitFactor === null ? 'text' : h.profitFactor >= 1 ? 'up' : 'down' },
    { k: 'Sharpe', v: fmtNum(h.sharpe), sub: 'risk-adjusted', tone: 'text' },
    { k: 'CAGR', v: fmtPct(h.cagrPct), sub: 'per year', tone: 'text' },
  ];
  return (
    <Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: 'repeat(6, minmax(0, 1fr))' }, gap: '1px', backgroundColor: tok('ink-08'), border: `1px solid ${tok('ink-08')}` }}>
        {tiles.map((t) => (
          <Box key={t.k} sx={{ backgroundColor: tok('surface'), p: 2, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            <Typography component="span" sx={{ ...LABEL, fontSize: '0.625rem', color: tok('ink-55') }}>{t.k}</Typography>
            <Typography component="span" sx={{ fontFamily: GROTESK, fontSize: '1.5rem', fontWeight: 600, letterSpacing: '-0.02em', color: tok(t.tone) }}>{t.v}</Typography>
            <Typography component="span" sx={{ fontFamily: MONO, fontSize: '0.75rem', color: tok('ink-50') }}>{t.sub}</Typography>
          </Box>
        ))}
      </Box>
      <Typography sx={{ fontFamily: MONO, fontSize: '0.6875rem', color: tok('ink-45'), mt: 0.75 }}>Basis: {h.basis}</Typography>
      <HypotheticalLegend sx={{ mt: 0.5 }} />
    </Box>
  );
}
